
import React from 'react';
import { TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScrollArea } from "@/components/ui/scroll-area";

import BasicsTab from './tabs/BasicsTab';
import CareerTab from './tabs/CareerTab';
import SkillsTab from './tabs/SkillsTab';
import ChallengesTab from './tabs/ChallengesTab';
import KpisTab from './tabs/KpisTab';
import SettingsTab from './tabs/SettingsTab';

const HelpGuideContent = () => {
  return (
    <>
      <TabsList className="grid grid-cols-6">
        <TabsTrigger value="basics">Basics</TabsTrigger>
        <TabsTrigger value="career">Career</TabsTrigger>
        <TabsTrigger value="skills">Skills</TabsTrigger>
        <TabsTrigger value="challenges">Challenges</TabsTrigger>
        <TabsTrigger value="kpis">KPIs</TabsTrigger>
        <TabsTrigger value="settings">Settings</TabsTrigger>
      </TabsList>
      
      <ScrollArea className="h-[60vh] mt-4 pr-4">
        <TabsContent value="basics">
          <BasicsTab />
        </TabsContent>
        
        <TabsContent value="career">
          <CareerTab />
        </TabsContent>
        
        <TabsContent value="skills">
          <SkillsTab />
        </TabsContent>
        
        <TabsContent value="challenges">
          <ChallengesTab />
        </TabsContent>
        
        <TabsContent value="kpis">
          <KpisTab />
        </TabsContent>
        
        <TabsContent value="settings">
          <SettingsTab />
        </TabsContent>
      </ScrollArea>
    </>
  );
};

export default HelpGuideContent;
